import React from "react";
import Header from "../Component/Services/After Sales Services/Header"
import SecendSection from "../Component/Services/After Sales Services/SecendSection"
import WideRange from "../Component/Services/After Sales Services/WideRange"
import QuickContact from "../Component/Services/QuickContact5"

function AfterSalesServices() {
  return <div>
    <Header /> 
    <SecendSection />
    <WideRange />
    <QuickContact />
  </div>;
}

export default AfterSalesServices;
